import type { ReactNode } from 'react'

type ButtonSize = 'md' | 'lg'
type ButtonVariant = 'primary' | 'assistive'

const BASE =
  'inline-flex cursor-pointer items-center justify-center border border-transparent font-base whitespace-nowrap disabled:cursor-not-allowed'

const SIZE: Record<ButtonSize, string> = {
  md: 'h-10 gap-1.5 rounded-[10px] px-3 py-2.5 text-body-sm font-semibold [&>svg]:h-5 [&>svg]:w-5 [&>svg]:shrink-0',
  lg: 'h-12 min-h-12 gap-2 rounded-xl px-4 py-3 text-body-md font-semibold [&>svg]:h-6 [&>svg]:w-6 [&>svg]:shrink-0',
}

const VARIANT: Record<ButtonVariant, string> = {
  primary:
    'bg-violet-500 text-white-50 hover:not-disabled:bg-violet-600 disabled:bg-white-300 disabled:text-white-500',
  assistive:
    'border-white-700 bg-white-50 text-black-600 hover:not-disabled:bg-white-200 disabled:border-white-300 disabled:bg-transparent disabled:text-white-500',
}

export function buttonStyles(
  size: ButtonSize,
  variant: ButtonVariant,
  className = '',
): string {
  return [BASE, SIZE[size], VARIANT[variant], className].filter(Boolean).join(' ')
}

export function Button({
  size = 'md',
  variant = 'primary',
  className = '',
  children,
  ...rest
}: {
  size?: ButtonSize
  variant?: ButtonVariant
  className?: string
  children: ReactNode
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'className'>) {
  return (
    <button type="button" className={buttonStyles(size, variant, className)} {...rest}>
      {children}
    </button>
  )
}
